<script setup lang="ts">
import Chart from 'chart.js/auto';
import {Model} from "@/app/Model";
import {RouterLink} from "vue-router";
import {onMounted, ref} from 'vue';
import * as bootstrap from 'bootstrap';
import type {KeyValoreStrNum, KeyValoreStrNumArr, KeyValoreStrNumBool} from "@/app/data/DataTypes";
import PaginazionePercorso from "@/components/atomics/PaginazionePercorsoFamiglia.vue";
import PaginazionePercorsoJump from "@/components/atomics/PaginazionePercorsoFamigliaJump.vue";
import {PdfGenerator} from "@/app/PdfGenerator";
import {CommsFamiglia, type IEsito} from "@/app/CommsFamiglia";

declare let frontendConfig: any;
declare let gtagO: Function;

//const initialTimeout: number = 1000;
let model: Model = Model.getReactiveInstance();
let chartOggettoDiGiudizio: Chart | null = null;
let chartTipologiaProcedimento: Chart | null = null;
let chartAddebito: Chart | null = null;
let chartMotiviAddebitoSeparazione: Chart | null = null;
let chartRegimeAffidamento: Chart | null = null;
let chartRegimeMantenimento: Chart | null = null;
let chartRegimeCollocamento: Chart | null = null;
const CHART_COLORS = {
  gfl1: 'rgb(33, 150, 243)',
  gfl2: 'rgb(22, 91, 170)',
  gfl3: 'rgb(79, 195, 247)',
  gfl4: 'rgb(19, 51, 113)',
  gfl5: 'rgb(227, 242, 253)',
  gfl6: 'rgb(41, 98, 255)',
  gfl7: 'rgb(161, 85, 185)',
  gfl8: 'rgb(22, 191, 214)'
};

onMounted(() => {
  checkStart();
});
function checkStart(): void {
  if (!Model.fam_setupped) {
    setTimeout(() => checkStart(), 100)
  } else if (!CommsFamiglia.listAllDone) {
    CommsFamiglia.getInstance().listAll(() => {
      checkStart();
    });
  } else {
    initComponents();
  }
}

//COMPONENTS
function initComponents(): void {

  //LO DEVE FARE?
  //chiama i dati attuali
  callQuery();
  //ALTRIMENTI
  //updateComponents();
}
window.addEventListener(
    "listAllRefresh",
    (event) => {
      updateComponents();
      //if (choices && model.fam_flow_percorso.capo_imputazione_legge != "") choices.setChoiceByValue(model.fam_flow_percorso.capo_imputazione_legge);
    }
);
window.addEventListener(
    "resetRefresh",
    (event) => {
      changePercorsoAt('all');
    }
);
function updateComponents(): void {
  //TOOLTIPS
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
  updateCharts();
  updatePaginazione();
}
function updateCharts(): void {
  updateChartsOggettoDiGiudizio();
  updateChartsTipologiaProcedimento();
  updateChartsAddebito();
  updateChartsMotiviAddebitoSeparazione();
  updateChartsRegimeAffidamento();
  updateChartsRegimeMantenimento();
  updateChartsRegimeCollocamento();
}

//CHARTS
function updateChartsOggettoDiGiudizio(): void {
  if (Chart.getChart("canvas_oggetto_di_giudizio")) {
    Chart.getChart("canvas_oggetto_di_giudizio")?.destroy();
  }
  if (model.fam_get_percorso.oggetto_di_giudizio.length > 0) {
    const configOggettoDiGiudizio = {
      type: 'doughnut',
      data: {
        labels: [],
        datasets: [{
          label: 'Oggetto del giudizio',
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          hoverOffset: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'right',
            onClick: null
          }
        }
      }
    };

    model.fam_get_percorso.oggetto_di_giudizio.forEach((x: KeyValoreStrNum) => {
      //@ts-ignore
      configOggettoDiGiudizio.data.labels.push(x.oggetto_di_giudizio + " (" + x.percentuale + "%)");

      //@ts-ignore
      configOggettoDiGiudizio.data.datasets[0].data.push(x.percentuale);
    });

    let canvasOggettoDiGiudizio: HTMLElement | null = document.getElementById('canvas_oggetto_di_giudizio');

    //@ts-ignore
    chartOggettoDiGiudizio = new Chart(canvasOggettoDiGiudizio, configOggettoDiGiudizio);
  }
}
function updateChartsTipologiaProcedimento(): void {
  if (Chart.getChart("canvas_tipologia_procedimento")) {
    Chart.getChart("canvas_tipologia_procedimento")?.destroy();
  }

  if (model.fam_get_percorso.tipologia_procedimento && model.fam_get_percorso.tipologia_procedimento.length > 0) {
    const configTipologiaProcedimento = {
      type: "doughnut",
      data: {
        labels: [],
        datasets: [{
          label: 'Tipologia Procedimento',
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          hoverOffset: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'right',
            onClick: null
          }
        }
      }
    }

    model.fam_get_percorso.tipologia_procedimento.forEach((x: KeyValoreStrNumArr) => {
      //@ts-ignore
      configTipologiaProcedimento.data.labels.push(x.tipologia_procedimento + " (" + x.percentuale + "%)");

      //@ts-ignore
      configTipologiaProcedimento.data.datasets[0].data.push(x.percentuale);
    });

    let canvasTipologiaProcedimento: HTMLElement | null = document.getElementById('canvas_tipologia_procedimento');

    //@ts-ignore
    chartTipologiaProcedimento = new Chart(canvasTipologiaProcedimento, configTipologiaProcedimento);

  }
}
function updateChartsAddebito(): void {
  if (Chart.getChart("canvas_addebito")) {
    Chart.getChart("canvas_addebito")?.destroy();
  }

  if (model.fam_get_percorso.addebito && model.fam_get_percorso.addebito.length > 0) {
    const configAddebito = {
      type: "doughnut",
      data: {
        labels: [],
        datasets: [{
          label: 'Addebito',
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          hoverOffset: 4
        }],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'right',
            onClick: null
          }
        }
      }
    }

    model.fam_get_percorso.addebito.forEach((x: KeyValoreStrNumBool) => {
      //@ts-ignore
      configAddebito.data.labels.push((x.addebito ? "Si" : "No") + " (" + x.percentuale + "%)");

      //@ts-ignore
      configAddebito.data.datasets[0].data.push(x.percentuale);
    });

    let canvasAddebito: HTMLElement | null = document.getElementById('canvas_addebito');

    //@ts-ignore
    chartAddebito = new Chart(canvasAddebito, configAddebito);
  }
}
function updateChartsMotiviAddebitoSeparazione(): void {
  if (Chart.getChart("canvas_motivi_addebito_separazione")) {
    Chart.getChart("canvas_motivi_addebito_separazione")?.destroy();
  }

  if (model.fam_get_percorso.motivi_addebito_separazione.length > 0) {
    const configMotiviAddebitoSeparazione = {
      type: 'doughnut',
      data: {
        labels: [],
        datasets: [{
          label: 'Motivi di addebito della separazione ',
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          hoverOffset: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'right',
            onClick: null
          }
        }
      }
    };

    model.fam_get_percorso.motivi_addebito_separazione.forEach((x: KeyValoreStrNum) => {
      //@ts-ignore
      configMotiviAddebitoSeparazione.data.labels.push(x.motivi_addebito_separazione + " (" + x.percentuale + "%)");

      //@ts-ignore
      configMotiviAddebitoSeparazione.data.datasets[0].data.push(x.percentuale);
    });

    let canvasMotiviAddebitoSeparazione: HTMLElement | null = document.getElementById('canvas_motivi_addebito_separazione');

    //@ts-ignore
    chartMotiviAddebitoSeparazione = new Chart(canvasMotiviAddebitoSeparazione, configMotiviAddebitoSeparazione);

  }
}
function updateChartsRegimeAffidamento(): void {
  if (Chart.getChart("canvas_regime_affidamento")) {
    Chart.getChart("canvas_regime_affidamento")?.destroy();
  }

  if (model.fam_get_percorso.regime_affidamento.length > 0) {
    const configRegimeAffidamento = {
      type: 'doughnut',
      data: {
        labels: [],
        datasets: [{
          label: 'Regime di affidamento',
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          hoverOffset: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'right',
            onClick: null
          }
        }
      }
    };

    model.fam_get_percorso.regime_affidamento.forEach((x: KeyValoreStrNum) => {
      //@ts-ignore
      configRegimeAffidamento.data.labels.push(x.regime_affidamento + " (" + x.percentuale + "%)");

      //@ts-ignore
      configRegimeAffidamento.data.datasets[0].data.push(x.percentuale);
    });

    let canvasRegimeAffidamento: HTMLElement | null = document.getElementById('canvas_regime_affidamento');

    //@ts-ignore
    chartRegimeAffidamento = new Chart(canvasRegimeAffidamento, configRegimeAffidamento);

  }
}
function updateChartsRegimeMantenimento(): void {
  if (Chart.getChart("canvas_regime_mantenimento")) {
    Chart.getChart("canvas_regime_mantenimento")?.destroy();
  }

  if (model.fam_get_percorso.regime_mantenimento.length > 0) {
    const configRegimeMantenimento = {
      type: 'doughnut',
      data: {
        labels: [],
        datasets: [{
          label: 'Regime di mantenimento',
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          hoverOffset: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'right',
            onClick: null
          }
        }
      }
    };

    model.fam_get_percorso.regime_mantenimento.forEach((x: KeyValoreStrNum) => {
      //@ts-ignore
      configRegimeMantenimento.data.labels.push(x.regime_mantenimento + " (" + x.percentuale + "%)");

      //@ts-ignore
      configRegimeMantenimento.data.datasets[0].data.push(x.percentuale);
    });

    let canvasRegimeMantenimento: HTMLElement | null = document.getElementById('canvas_regime_mantenimento');

    //@ts-ignore
    chartRegimeMantenimento = new Chart(canvasRegimeMantenimento, configRegimeMantenimento);

  }
}
function updateChartsRegimeCollocamento(): void {
  if (Chart.getChart("canvas_regime_collocamento")) {
    Chart.getChart("canvas_regime_collocamento")?.destroy();
  }

  if (model.fam_get_percorso.regime_collocamento.length > 0) {
    const configRegimeCollocamento = {
      type: 'doughnut',
      data: {
        labels: [],
        datasets: [{
          label: 'Regime di collocamento',
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          hoverOffset: 4
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'right',
            onClick: null
          }
        }
      }
    };

    model.fam_get_percorso.regime_collocamento.forEach((x: KeyValoreStrNum) => {
      //@ts-ignore
      configRegimeCollocamento.data.labels.push(x.regime_collocamento + " (" + x.percentuale + "%)");

      //@ts-ignore
      configRegimeCollocamento.data.datasets[0].data.push(x.percentuale);
    });

    let canvasRegimeCollocamento: HTMLElement | null = document.getElementById('canvas_regime_collocamento');

    //@ts-ignore
    chartRegimeCollocamento = new Chart(canvasRegimeCollocamento, configRegimeCollocamento);

  }
}

//QUERY
function callQueryPaginazione(): void {
  callQuery(true);
}
function callQuery(soloPaginazione: boolean = false): void {
  //chiama i dati attuali
  CommsFamiglia.getInstance().queryPercorso((e: IEsito) => {
    updateComponents();
  }, soloPaginazione);
}

//FLOW
function changePercorsoAt(field: string): void {
  let valueField = "";
  let stringField = "";
  
  //pulire i successivi in model.fam_flow_percorso
  if (field == "all") {
    model.fam_flow_percorso.oggetto_di_giudizio = "";
    field = "oggetto_di_giudizio"
  }

  stringField = field;

  switch (field) {
    case "oggetto_di_giudizio":
      model.fam_flow_percorso.tipologia_procedimento = "";
      model.fam_flow_percorso.addebito = "";
      model.fam_flow_percorso.motivi_addebito_separazione = "";
      model.fam_flow_percorso.figli = false;
      model.fam_flow_percorso.regime_affidamento = "";
      model.fam_flow_percorso.regime_collocamento = "";
      model.fam_flow_percorso.regime_mantenimento = "";

      valueField = model.fam_flow_percorso.oggetto_di_giudizio;
      stringField = "oggetto del giudizio";

      break;
    case "tipologia_procedimento":
      model.fam_flow_percorso.addebito = "";
      model.fam_flow_percorso.motivi_addebito_separazione = "";
      model.fam_flow_percorso.figli = false;
      model.fam_flow_percorso.regime_affidamento = "";
      model.fam_flow_percorso.regime_collocamento = "";
      model.fam_flow_percorso.regime_mantenimento = "";

      valueField = model.fam_flow_percorso.tipologia_procedimento;
      stringField = "tipologia procedimento";

      break;
    case "addebito":
      model.fam_flow_percorso.motivi_addebito_separazione = "";
      model.fam_flow_percorso.figli = false;
      model.fam_flow_percorso.regime_affidamento = "";
      model.fam_flow_percorso.regime_collocamento = "";
      model.fam_flow_percorso.regime_mantenimento = "";

      valueField = model.fam_flow_percorso.addebito;

      break;
    case "motivi_addebito_separazione":
      model.fam_flow_percorso.figli = false;
      model.fam_flow_percorso.regime_affidamento = "";
      model.fam_flow_percorso.regime_collocamento = "";
      model.fam_flow_percorso.regime_mantenimento = "";

      valueField = model.fam_flow_percorso.motivi_addebito_separazione;
      stringField = "motivi di addebito della separazione";

      break;
    case "figli":
      model.fam_flow_percorso.regime_affidamento = "";
      model.fam_flow_percorso.regime_collocamento = "";
      model.fam_flow_percorso.regime_mantenimento = "";

      valueField = model.fam_flow_percorso.figli + "";

      if (valueField == "true") {
        valueField = "sì"
      } else {
        valueField = ""
      }

      break;
    case "regime_affidamento":
      valueField = model.fam_flow_percorso.regime_affidamento;
      stringField = "regime di affidamento";
      
      break;
    case "regime_collocamento":
      valueField = model.fam_flow_percorso.regime_collocamento;
      stringField = "regime di collocamento";

      break;
    case "regime_mantenimento":
      valueField = model.fam_flow_percorso.regime_mantenimento;
      stringField = "regime di mantenimento";

      break;
  }

  if (valueField) {
    gtagO({
      event: 'filtro',
      filtro: stringField,
      valore: valueField,
      percorso: 'Famiglia'
    })
  }

  callQuery();
}
function canShowCanvas(field: string): string {
  let stylo: string = "row blocco";
  switch (field) {
    case "oggetto_di_giudizio":
      break;
    case "tipologia_procedimento":
      if (!model.fam_get_percorso.tipologia_procedimento || model.fam_get_percorso.tipologia_procedimento.length < 1 ||
          model.fam_flow_percorso.oggetto_di_giudizio == "") stylo += " not-visible";
      break;
    case "addebito":
      if (!model.fam_get_percorso.addebito || model.fam_get_percorso.addebito.length < 1 ||
          model.fam_flow_percorso.oggetto_di_giudizio == "" || model.fam_flow_percorso.tipologia_procedimento == "" ||
          model.fam_flow_percorso.oggetto_di_giudizio != Model.lista_oggetto_di_giudizio[1] ||
          model.fam_flow_percorso.tipologia_procedimento == Model.lista_tipologia_procedimento_percorso[0]

      ) stylo += " not-visible";
      break;
    case "motivi_addebito_separazione":
      if (!model.fam_get_percorso.motivi_addebito_separazione || model.fam_get_percorso.motivi_addebito_separazione.length < 1 ||
          model.fam_flow_percorso.oggetto_di_giudizio == "" || model.fam_flow_percorso.tipologia_procedimento == "" ||
          model.fam_flow_percorso.addebito == "" || model.fam_flow_percorso.addebito == "No" ||
          model.fam_flow_percorso.oggetto_di_giudizio != Model.lista_oggetto_di_giudizio[1]
      ) stylo += " not-visible";
      break;
    case "regime_affidamento":
      if (!model.fam_get_percorso.regime_affidamento || model.fam_get_percorso.regime_affidamento.length < 1 ||
          model.fam_flow_percorso.oggetto_di_giudizio == "" || model.fam_flow_percorso.tipologia_procedimento == ""|| !model.fam_flow_percorso.figli) {
        stylo += " not-visible";
      }
      break;
    case "regime_collocamento":
      if (!model.fam_get_percorso.regime_collocamento || model.fam_get_percorso.regime_collocamento.length < 1 ||
          model.fam_flow_percorso.oggetto_di_giudizio == "" || model.fam_flow_percorso.tipologia_procedimento == ""|| !model.fam_flow_percorso.figli) {
        stylo += " not-visible";
      }
      break;
    case "regime_mantenimento":
      if (!model.fam_get_percorso.regime_mantenimento || model.fam_get_percorso.regime_mantenimento.length < 1 ||
          model.fam_flow_percorso.oggetto_di_giudizio == "" || model.fam_flow_percorso.tipologia_procedimento == ""|| !model.fam_flow_percorso.figli) {
        stylo += " not-visible";
      }
      break;
  }
  return stylo
}
function canShowField(field: string): string {
  let canShow: string = "row blocco";
  switch (field) {
    case "oggetto_di_giudizio":
      break;
    case "tipologia_procedimento":
      if (model.fam_flow_percorso.oggetto_di_giudizio == ""
      ) canShow += " not-visible";
      break;
    case "addebito":
      if (model.fam_flow_percorso.oggetto_di_giudizio == "" || model.fam_flow_percorso.tipologia_procedimento == "" ||
          model.fam_flow_percorso.oggetto_di_giudizio != Model.lista_oggetto_di_giudizio[1] ||
          model.fam_flow_percorso.tipologia_procedimento == Model.lista_tipologia_procedimento_percorso[0]
      ) canShow += " not-visible";
      break;
    case "motivi_addebito_separazione":
      if (model.fam_flow_percorso.oggetto_di_giudizio == "" || model.fam_flow_percorso.tipologia_procedimento == "" ||
          model.fam_flow_percorso.addebito == "" || model.fam_flow_percorso.addebito == "No" ||
          model.fam_flow_percorso.oggetto_di_giudizio != Model.lista_oggetto_di_giudizio[1]
      ) canShow += " not-visible";
      break;
    case "figli":
      if (model.fam_flow_percorso.oggetto_di_giudizio == "" || model.fam_flow_percorso.tipologia_procedimento == "") {
        canShow += " not-visible";
      }
      break;
    case "regime_affidamento":
    case "regime_collocamento":
    case "regime_mantenimento":
      if (model.fam_flow_percorso.oggetto_di_giudizio == "" || model.fam_flow_percorso.tipologia_procedimento == ""|| !model.fam_flow_percorso.figli) {
        canShow += " not-visible";
      }
      break;
    case "finePercorso":
      if (model.fam_flow_percorso.oggetto_di_giudizio == "" || model.fam_flow_percorso.tipologia_procedimento == "" ||
          (model.fam_flow_percorso.oggetto_di_giudizio == Model.lista_oggetto_di_giudizio[1] &&
          model.fam_flow_percorso.tipologia_procedimento != Model.lista_tipologia_procedimento_percorso[0] && (model.fam_flow_percorso.addebito == "" || (model.fam_flow_percorso.addebito == "Si" && model.fam_flow_percorso.motivi_addebito_separazione == "" ) ))) {
        canShow += " not-visible";
      }
      break;
  }
  return canShow;
}

//DASH
function vaiDashboard(): void {
  gtagO({
    event: 'link dashboard', 
    posizione: 'bottom Percorso',
    percorso: 'famiglia'
  })
}

//DOCUMENTI
function apriDocumenti(): void {
  gtagO({
    event: 'elenco sentenze'
  })

  let docDiv: HTMLElement | null = document.getElementById("percorsoDocumenti");
  if (docDiv) docDiv.style.display = "block";
}
function sintetizzaConAi(estremi: string, id_doc_master: number, docRigaIndex: number): void {
  gtagO({
    event: 'sintetizza AI',
    target: estremi
  })

  let model: Model = Model.getReactiveInstance();
  CommsFamiglia.getInstance().openSintesi('famiglia-percorso', docRigaIndex, {
    id_doc_master: id_doc_master,
    username: model.user.profile.userId,
    crmid: model.user.profile.crmId
  });
}
function apriDettaglio(estremi: string = "", id_doc_master: number = -1, id_databanks: number = -1, id: string = ""): void {
  gtagO({
    event: 'apri dettaglio',
    target: estremi,
    destinazione: model.abbonatoDejure ? 'dejure' : 'overlay'
  })

  let comms: CommsFamiglia = CommsFamiglia.getInstance();
  if (id_doc_master < 0) {
    if (!model.openingDejure) {
      let allIds: number[] = [];
      model.fam_get_percorso.sentenze_paginate.forEach((item: KeyValoreStrNum) => {
        if (item.estremi) {
          allIds.push(item.id_doc_master as number)
        }
      })
      if (model.abbonatoDejure) {
        model.openingDejure = true;
        comms.callDejure(allIds, ()=> { model.openingDejure = false});
      }
    }
  } else {
    if (model.abbonatoDejure) {
      comms.openDettaglioDejure(id_doc_master, id_databanks, id);
    } else {
      comms.openDettaglioModal(id_doc_master, id_databanks, id);
    }
  }
}

//PAGINAZIONE
const paginazione_component = ref(null);
const paginazione_jump_component = ref(null);

const updatePaginazione = (): void => {
  try {
    //@ts-ignore
    paginazione_component.value.updatePaginazione();
    //@ts-ignore
    if (paginazione_jump_component && paginazione_jump_component.value) paginazione_jump_component.value.updatePaginazione();
  } catch (e) {
    //console.log("%%%%", e)
  }
}

//REPORT
function generaReport(): void {
  let sFiltriAttivi = "";

  if (model.fam_flow_percorso.oggetto_di_giudizio != "") {
    sFiltriAttivi = "Oggetto di Giudizio";
  }
  if (model.fam_flow_percorso.tipologia_procedimento) {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Tipologia procedimento";
  }
  if (model.fam_flow_percorso.addebito != "") {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Addebito";
  }
  if (model.fam_flow_percorso.motivi_addebito_separazione != "") {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Motivi addebito separazione";
  }
  if (model.fam_flow_percorso.regime_affidamento != "") {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Regime affidamento";
  }
  if (model.fam_flow_percorso.regime_collocamento != "") {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Regime collocamento";
  }
  if (model.fam_flow_percorso.regime_mantenimento != "") {
    if (sFiltriAttivi != "") { sFiltriAttivi += "|" }
    sFiltriAttivi += "Regime mantenimento";
  }

  PdfGenerator.fam_generatePdfPercorso("famiglia");
  gtagO({
    event: 'genera report',
    filtriAttivi: sFiltriAttivi
  })
}

function isRebranding(): boolean {
  return frontendConfig.rebranding;
}
</script>

<template>
  <div class="container percorso percorso-page">

    <!-- OGGETTO DI GIUDIZIO -->
    <div :class="canShowCanvas('oggetto_di_giudizio')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        <div class="row">
          <div class="col-4 p-2">
            &nbsp;<button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true" id="tooltip_oggetto_di_giudizio"
                          data-bs-title="Questo grafico ti permette di visualizzare la distribuzione tra le sentenze relative ai procedimenti di Separazione e a quelle relative allo scioglimento del
                vincolo matrimoniale e alla cessazione degli effetti civili, entrambe ricomprese nell’etichetta Divorzio.">
            <i class="bi bi-info-circle-fill"></i>
          </button>
            <h6>Oggetto del giudizio</h6><br>
            <em>Numero sentenze prese in esame</em><br>
            {{ model.fam_get_percorso.totale_numero_sentenze.valore }}
          </div>
          <div class="col-8 canvasCont"><canvas id="canvas_oggetto_di_giudizio"></canvas></div>
        </div>
      </div>
    </div>
    <div :class="canShowField('oggetto_di_giudizio')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Scegli il tipo di procedimento da analizzare
      </div>
      <div class="col-1 pt-3">

      </div>
      <div class="col-11 p-3 px-0">
        <select class="form-select" id="input_oggetto_di_giudizio"
                v-model="model.fam_flow_percorso.oggetto_di_giudizio"
                @change="changePercorsoAt('oggetto_di_giudizio')">
          <option value="">Scegli...</option>
          <option v-for="(item) in Model.lista_oggetto_di_giudizio" :value="item" :key="'oggetto_di_giudizio_' + item">
            {{item}}
          </option>
        </select>
      </div>
    </div>

    <!-- TIPOLOGIA PROCEDIMENTO -->
    <div :class="canShowCanvas('tipologia_procedimento')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        <div class="row">
            <div class="col-4 p-2">
              &nbsp;<button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true" id="tooltip_tipologia_procedimento"
                      data-bs-title="Questo grafico ti permette di visualizzare la distribuzione tra le diverse tipologie di procedimento, consensuali o
                giudiziali.">
                <i class="bi bi-info-circle-fill"></i>
              </button>
              <h6>Tipologia Procedimento</h6><br>
              <em>Numero sentenze prese in esame</em><br>
              {{ model.fam_get_percorso.totale_numero_sentenze.valore }}
            </div>
            <div class="col-8 canvasCont"><canvas id="canvas_tipologia_procedimento"></canvas></div>
        </div>
      </div>
    </div>
    <div :class="canShowField('tipologia_procedimento')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Specifica se si tratta di procedimento consensuale o giudiziale
      </div>
      <div class="col-1 pt-3">
        &nbsp;
      </div>
      <div class="col-11 p-3 px-0">
        <select class="form-select" id="input_tipologia_procedimento" v-model="model.fam_flow_percorso.tipologia_procedimento"
                @change="changePercorsoAt('tipologia_procedimento')">
          <option value="">Scegli...</option>
          <template v-if="model.fam_get_percorso.tipologia_procedimento && model.fam_get_percorso.tipologia_procedimento.length > 0">
          <option v-for="(item, index) in model.fam_get_percorso.tipologia_procedimento" :value="item.tipologia_procedimento" :key="'tipologia_procedimento_'+index">{{ item.tipologia_procedimento }}</option>
          </template>
          <template v-else>
            <option v-for="(item, index) in Model.lista_tipologia_procedimento_percorso" :value="item" :key="'esito_'+item">{{ item }}</option>
          </template>
        </select>
      </div>
    </div>

    <!-- ADDEBITO -->
    <div :class="canShowCanvas('addebito')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        <div class="row">
          <div class="col-4 p-2">
            &nbsp;<button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true" id="tooltip_addebito"
                    data-bs-title="Questo grafico ti permette di visualizzare la distribuzione tra le sentenze in cui vi è addebito della separazione oppure no.">
              <i class="bi bi-info-circle-fill"></i>
            </button>
            <h6>Addebito</h6><br>
            <em>Numero sentenze prese in esame</em><br>
            {{ model.fam_get_percorso.totale_numero_sentenze.valore }}
          </div>
          <div class="col-8 canvasCont"><canvas id="canvas_addebito"></canvas></div>
        </div>
      </div>
    </div>
    <div :class="canShowField('addebito')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Scegli se analizzare le separazioni in cui vi è addebito
      </div>
      <div class="col-1 pt-3">
        &nbsp;
      </div>
      <div class="col-11 p-3 px-0">
        <select class="form-select" id="input_addebito" v-model="model.fam_flow_percorso.addebito"
                @change="changePercorsoAt('addebito')">
          <option value="">Scegli...</option>
          <template v-if="model.fam_get_percorso.addebito && model.fam_get_percorso.addebito.length > 0">
            <option v-for="(item, index) in model.fam_get_percorso.addebito" :value="(item.addebito ? 'Si' : 'No')" :key="'addebito_'+index"><span v-if="item.addebito.toString() === 'true'">Si</span><span v-else>No</span></option>
          </template>
          <template v-else>
            <option v-for="(item, index) in Model.lista_addebito" :value="item" :key="'esito_'+item">{{ item }}</option>
          </template>
        </select>
      </div>
    </div>

    <!-- MOTIVI_ADDEBITO_SEPARAZIONE -->
    <div :class="canShowCanvas('motivi_addebito_separazione')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        <div class="row">
          <div class="col-4 p-2">
            &nbsp;<button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true" id="tooltip_motivi_addebito_separazione"
                    data-bs-title="Questo grafico ti permette di visualizzare la distribuzione fra i motivi che hanno portato all’addebito della separazione.">
              <i class="bi bi-info-circle-fill"></i>
            </button>
            <h6>Motivi di addebito della separazione</h6><br>
            <em>Numero sentenze prese in esame</em><br>
            {{ model.fam_get_percorso.totale_numero_sentenze.valore }}
          </div>
          <div class="col-8 canvasCont"><canvas id="canvas_motivi_addebito_separazione"></canvas></div>
        </div>
      </div>
    </div>
    <div :class="canShowField('motivi_addebito_separazione')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Scegli ora tra i motivi che hanno portato all’addebito
      </div>
      <div class="col-1 pt-3">
        &nbsp;
      </div>
      <div class="col-11 p-3 px-0">
        <select class="form-select" id="input_motivi_addebito_separazione" v-model="model.fam_flow_percorso.motivi_addebito_separazione"
                @change="changePercorsoAt('motivi_addebito_separazione')">
          <option value="">Scegli...</option>
          <template v-if="model.fam_get_percorso.motivi_addebito_separazione && model.fam_get_percorso.motivi_addebito_separazione.length > 0">
            <option v-for="(item, index) in model.fam_get_percorso.motivi_addebito_separazione" :value="item.motivi_addebito_separazione" :key="'motivi_addebito_separazione_'+index">{{ item.motivi_addebito_separazione }}</option>
          </template>
          <template v-else>
            <option v-for="(item, index) in Model.lista_motivi_addebito_separazione" :value="item" :key="'esito_'+item">{{ item }}</option>
          </template>
        </select>
      </div>
    </div>

    <!-- FIGLI -->
    <div :class="canShowField('figli')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Vuoi analizzare procedimenti che prevedono aspetti legati ai figli?
      </div>
      <div class="col-1 pt-3">

      </div>
      <div class="col-11 p-3 px-0">
        <label class="form-check-label" for="input_figli">Seleziona la casella in caso affermativo.</label>
        <input type="checkbox" class="form-check" id="input_figli"
               v-model="model.fam_flow_percorso.figli"
               @change="changePercorsoAt('figli')" />

      </div>
    </div>

    <!-- REGIME_AFFIDAMENTO -->
    <div :class="canShowCanvas('regime_affidamento')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        <div class="row">
          <div class="col-4 p-2">
            &nbsp;<button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true" id="tooltip_regime_affidamento"
                    data-bs-title="Questo grafico ti permette di visualizzare la distribuzione la tipologia di affidamento dei figli nell’ambito della separazione.">
              <i class="bi bi-info-circle-fill"></i>
            </button>
            <h6>Regime di affidamento</h6><br>
            <em>Numero sentenze prese in esame</em><br>
            {{ model.fam_get_percorso.totale_numero_sentenze.valore }}
          </div>
          <div class="col-8 canvasCont"><canvas id="canvas_regime_affidamento"></canvas></div>
        </div>
      </div>
    </div>
    <div :class="canShowField('regime_affidamento')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Indica la tipologia di affidamento
      </div>
      <div class="col-1 pt-3">
        &nbsp;
      </div>
      <div class="col-11 p-3 px-0">
        <select class="form-select" id="input_regime_affidamento" v-model="model.fam_flow_percorso.regime_affidamento"
                @change="changePercorsoAt('regime_affidamento')">
          <option value="">Scegli...</option>
          <template v-if="model.fam_get_percorso.regime_affidamento && model.fam_get_percorso.regime_affidamento.length > 0">
            <option v-for="(item, index) in model.fam_get_percorso.regime_affidamento" :value="item.regime_affidamento" :key="'regime_affidamento_'+index">{{ item.regime_affidamento }}</option>
          </template>
          <template v-else>
            <option v-for="(item, index) in Model.lista_regime_affidamento" :value="item" :key="'esito_'+item">{{ item }}</option>
          </template>
        </select>
      </div>
    </div>

    <!-- REGIME_COLLOCAMENTO -->
    <div :class="canShowCanvas('regime_collocamento')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        <div class="row">
          <div class="col-4 p-2">
            &nbsp;<button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true" id="tooltip_regime_collocamento"
                    data-bs-title="Il grafico permette di visualizzare la distribuzione fra i diversi regimi di collocamento.">
              <i class="bi bi-info-circle-fill"></i>
            </button>
            <h6>Regime di collocamento</h6><br>
            <em>Numero sentenze prese in esame</em><br>
            {{ model.fam_get_percorso.totale_numero_sentenze.valore }}
          </div>
          <div class="col-8 canvasCont"><canvas id="canvas_regime_collocamento"></canvas></div>
        </div>
      </div>
    </div>
    <div :class="canShowField('regime_collocamento')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Scegli tra le diverse ipotesi di collocamento
      </div>
      <div class="col-1 pt-3">
        &nbsp;
      </div>
      <div class="col-11 p-3 px-0">
        <select class="form-select" id="input_regime_collocamento" v-model="model.fam_flow_percorso.regime_collocamento"
                @change="changePercorsoAt('regime_collocamento')">
          <option value="">Scegli...</option>
          <template v-if="model.fam_get_percorso.regime_collocamento && model.fam_get_percorso.regime_collocamento.length > 0">
            <option v-for="(item, index) in model.fam_get_percorso.regime_collocamento" :value="item.regime_collocamento" :key="'regime_collocamento_'+index">{{ item.regime_collocamento }}</option>
          </template>
          <template v-else>
            <option v-for="(item, index) in Model.lista_regime_collocamento" :value="item" :key="'esito_'+item">{{ item }}</option>
          </template>
        </select>
      </div>
    </div>

    <!-- REGIME_MANTENIMENTO -->
    <div :class="canShowCanvas('regime_mantenimento')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        <div class="row">
          <div class="col-4 p-2">
            &nbsp;<button type="button" class="btn btn-tooltip" data-bs-toggle="tooltip" data-bs-html="true" id="tooltip_regime_mantenimento"
                    data-bs-title="Il grafico permette di visualizzare la distribuzione fra i due diversi regimi di mantenimento.">
              <i class="bi bi-info-circle-fill"></i>
            </button>
            <h6>Regime di mantenimento</h6><br>
            <em>Numero sentenze prese in esame</em><br>
            {{ model.fam_get_percorso.totale_numero_sentenze.valore }}
          </div>
          <div class="col-8 canvasCont"><canvas id="canvas_regime_mantenimento"></canvas></div>
        </div>
      </div>
    </div>
    <div :class="canShowField('regime_mantenimento')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Scegli il regime di mantenimento
      </div>
      <div class="col-1 pt-3">
        &nbsp;
      </div>
      <div class="col-11 p-3 px-0">
        <select class="form-select" id="input_regime_mantenimento" v-model="model.fam_flow_percorso.regime_mantenimento"
                @change="changePercorsoAt('regime_mantenimento')">
          <option value="">Scegli...</option>
          <template v-if="model.fam_get_percorso.regime_mantenimento && model.fam_get_percorso.regime_mantenimento.length > 0">
            <option v-for="(item, index) in model.fam_get_percorso.regime_mantenimento" :value="item.regime_mantenimento" :key="'regime_mantenimento_'+index">{{ item.regime_mantenimento }}</option>
          </template>
          <template v-else>
            <option v-for="(item, index) in Model.lista_regime_mantenimento" :value="item" :key="'esito_'+item">{{ item }}</option>
          </template>
        </select>
      </div>
    </div>

    <!-- FINE PERCORSO -->
    <div :class="canShowField('finePercorso')">
      <div class="col-1">
        <img v-if="!isRebranding()" alt="-" src="@/assets/favicon.svg" width="37"/>
        <img v-if="isRebranding()" alt="-" src="@/assets/new_favicon.svg" width="30"/>
      </div>
      <div class="col-11 bg-body-tertiary rounded-2 colodestra">
        Hai completato il percorso di analisi guidato sulle sentenze <span v-if="model.fam_flow_percorso.oggetto_di_giudizio !=''">di <em>{{model.fam_flow_percorso.oggetto_di_giudizio}}</em></span>
      </div>
      <div class="col-1 pt-3">
        &nbsp;
      </div>
      <div class="col-11 p-3 px-0 finepercorso">
        <div class="mb-2">Ora puoi scegliere tra due opzioni:<br>
          &bull; Genera l’elenco delle sentenze corrispondenti alle tue scelte.<br>
          &bull; Accedi alla dashboard per ulteriori analisi.<br>
          &nbsp; Qui potrai consultare i dati in base a vari criteri come:
          <span v-if="model.fam_flow_percorso.oggetto_di_giudizio !='Divorzio'">Tribunale, Giudice, durata del processo, assegnazione casa coniugale, Valore assegno di mantenimento, Valore assegno per il contributo al mantenimento</span>
          <span v-else>Tribunale, Giudice, durata del processo, assegnazione casa coniugale, Valore assegno di mantenimento, Valore assegno per il contributo al mantenimento, Valore assegno divorzio</span>
          .<br>

          <button class="btn btn-lg btn-error my-3" @click="apriDocumenti()">
            <i class="bi bi-file-earmark"></i> &nbsp; Elenco Sentenze
          </button>
          <RouterLink to="/famiglia/dashboard" class="btn btn-lg btn-error my-3" @click="vaiDashboard()">
            <i class="bi bi-graph-up"></i> &nbsp; Vai alla Dashboard
          </RouterLink>
        </div>

        <div id="percorsoDocumenti" class="pt-3" style="display: none">
          <h4>Elenco sentenze</h4>

          <div class="table-responsive small table-documenti"  v-if="model.fam_get_percorso.sentenze_paginate && model.fam_get_percorso.sentenze_paginate.length && model.fam_get_percorso.sentenze_paginate.length > 0">
            <table class="table table-striped table-sm">
              <tbody>
              <template v-for="(item, index) in model.fam_get_percorso.sentenze_paginate">
                <tr v-if="item.estremi" :id="'docRiga-famiglia-percorso-'+index">
                  <!-- td><em>{{ (new Date(item.date)).toLocaleDateString() }}</em></td -->
                  <td>{{item.estremi}}</td>
                  <td class="text-right">
                    <a href="javascript:void(0)" @click="sintetizzaConAi(item.estremi as string, item.id_doc_master as number, index)" v-if="item.tipologia_doc != 136">
                      <i class="bi bi-stars"></i> Sintetizza con AI
                    </a>
                    <span v-else> </span>
                  </td>
                  <td class="text-right">
                    <a href="javascript:void(0)" @click="apriDettaglio(item.estremi as string, item.id_doc_master as number, item.id_databanks as number, item.id as string)">
                      <i class="bi bi-link"></i> Apri dettaglio
                    </a>
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>

          <div class="row"  v-if="model.fam_get_percorso.sentenze_paginate && model.fam_get_percorso.sentenze_paginate.length && model.fam_get_percorso.sentenze_paginate.length > 0">

            <div class="col-12 col-sm-6 col-xl-4 paginazione-azione">
              <button class="btn btn-sm btn-primary" @click="apriDettaglio()" v-if="model.abbonatoDejure"><i class="bi bi-box-arrow-up-right" v-if="!model.openingDejure"></i> <div v-else class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>&nbsp;  Approfondisci su DeJure</button>

              <button class="btn btn-sm btn-error" @click="generaReport()" v-if="model.fam_flow_percorso.oggetto_di_giudizio != ''">
                <i class="bi bi-download" v-if="!model.generatingPdf"></i> 
                <div v-else class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                &nbsp; Genera report
              </button>
            </div>

            <div class="col-12 col-sm-6 col-xl-3 paginazione-label">
              <b>{{ model.fam_flow_percorso.paginazione_tot }}</b> Elementi Totali |
              Pagina <b>{{ (model.fam_flow_percorso.paginazione_start + 1) }}</b> di
              <b>{{ (model.fam_flow_percorso.paginazione_pages + 1) }}</b>
            </div>
            <div class="col-12 col-sm-12 col-xl-5">
              <PaginazionePercorso ref="paginazione_component" @recalc="callQueryPaginazione()"></PaginazionePercorso>
            </div>

            <!-- principi di diritto -->
            <div class="col-12 mt-4" v-if="model.abbonatoDejure && model.fam_get_percorso.sentenze_paginate_jump_display && model.fam_get_percorso.sentenze_paginate_jump_display.length && model.fam_get_percorso.sentenze_paginate_jump_display.length > 0">
              <h4>Principi di diritto</h4>
              <div class="table-responsive small table-documenti">
                <table class="table table-striped table-sm">
                  <tbody>
                  <template v-for="(item, index) in model.fam_get_percorso.sentenze_paginate_jump_display">
                    <tr v-if="item.estremi || item.id_doc_master" :id="'docRiga-famiglia-percorso-jump-'+index">
                      <td v-if="item.estremi">{{item.estremi}}</td>
                      <td v-else> {{item.id_doc_master}}</td>
                      <td class="text-right">
                        <a href="javascript:void(0)" @click="apriDettaglio(item.estremi as string, item.id_doc_master as number, item.id_databanks as number, item.id as string)">
                          <i class="bi bi-link"></i> Apri dettaglio
                        </a>
                      </td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>

              <div class="row">
                <div class="col-12 col-sm-6 col-xl-4 paginazione-azione">

                </div>
                <div class="col-12 col-sm-6 col-xl-3 paginazione-label">
                  <b>{{ model.fam_flow_percorso.diritto_paginazione_tot }}</b> Elementi Totali |
                  Pagina <b>{{ (model.fam_flow_percorso.diritto_paginazione_start + 1) }}</b> di
                  <b>{{ (model.fam_flow_percorso.diritto_paginazione_pages + 1) }}</b>
                </div>
                <div class="col-12 col-sm-12 col-xl-5">
                  <PaginazionePercorsoJump ref="paginazione_jump_component"></PaginazionePercorsoJump>
                </div>
              </div>


            </div>

          </div>
          <div class="row" v-else>
            <div class="col-12">
              Non sono presenti sentenze
            </div>
          </div>

        </div>
      </div>

    </div>

  </div>

</template>